import { createSelector } from 'reselect';
export const selectHubspotCredits = createSelector(state => state.appConfig.navExtensionTriggers, navExtensionTriggers => navExtensionTriggers.hubspotCredits);